//chrome;
window.scrollDesignModeInVal = false;
window.scrollSourceModeInVal = false;
(function($) {
    RVwys.runEvents_DesignView = function(oEditor) {
        var obj = this;
        $(oEditor).click(function() {
            var thisEditor = this;
            parent.RVwys.currentEditor = document;
            parent.RVwys.currentiFrame = thisEditor;

            obj.currentiFrame = thisEditor;
            obj.setFocus();
            setTimeout(function() {
                obj.displaySource(thisEditor);
            }, 50);
        });
        $(oEditor).keydown(function(e) {
            if (obj.processUpdateSource) {
                clearTimeout(obj.processUpdateSource);
                $(obj.currentiFrame)
                    .find('focus')
                    .remove();
                $(obj.currentiFrame)
                    .find('endfocus')
                    .remove();
            }
        });

        $(oEditor).mousedown(function(e) {
            var oThis = $(this);
            $('.editorCurrentActive')
                .removeClass('editorCurrentActive')
                .end()
                .each(function() {
                    oThis.addClass('editorCurrentActive');
                });
            parent.pointerMode = 'design';
            var oFocusDesign = $(obj.currentiFrame).find('focus');
            var oEndFocusDesign = $(obj.currentiFrame).find('endfocus');
            var oFocusObjDesign = $(obj.currentiFrame).find('.focus');

            if (oFocusDesign.get(0)) {
                if (oFocusDesign.text() != '') {
                    oFocusDesign.replaceWith(oFocusDesign.text());
                } else {
                    oFocusDesign.remove();
                }
            }
            if (oEndFocusDesign.get(0)) {
                if (oEndFocusDesign.text() != '') {
                    oEndFocusDesign.replaceWith(oEndFocusDesign.text());
                } else {
                    oEndFocusDesign.remove();
                }
            }
            if (oFocusObjDesign.get(0)) {
                if (oFocusObjDesign.html() != '') {
                    oFocusObjDesign.replaceWith(oFocusObjDesign.html());
                } else {
                    oFocusObjDesign.remove();
                }
            }
        });

        $(oEditor).keyup(function(e) {
            if (obj.processUpdateSource) {
                clearTimeout(obj.processUpdateSource);
            }
            obj.activeEventButtonStarte();
            obj.processUpdateSource = setTimeout(function() {
                obj.updateSource();
                clearTimeout(this);
            }, 1000);
        });

        $(oEditor).mouseup(function(e) {
            var range = RVwys.getRange();
            if (range) {
                obj.activeEventButtonStarte();
                obj.updateSource();
            }
        });

        $(oEditor).focus(function(e) {
            var thisEditor = this;
            parent.RVwys.currentEditor = document;
            parent.RVwys.currentiFrame = thisEditor;
            RVwys.currentiFrame = thisEditor;
            RVwys.setFocus();
            if ($(RVwys.currentiFrame).html() == '<br>') {
                $(RVwys.currentiFrame).html('<div></div>');
            }

            setTimeout(function() {
                parent.RVwys.displaySource(thisEditor);
                obj.updateSource();
            }, 50);
        });
        $(oEditor).blur(function() {
            RVwys.setBlur();
        });
        // pluglins register event
        $.each(this.oEventsDesignView, function(k, v) {
            var func = v.func;
            $(oEditor).bind(v.event, func);
        });
        $.each(this.oEventsDesignViewByWidget, function(k, v) {
            var func = v.func;
            let eov = k.split(':');
            if (Array.isArray(eov)) {
                $(oEditor).bind(eov[1], func);
            }
        });

        return this;
    };

    RVwys.reSelectRange = function(range) {
        return range;
    };

    RVwys.getRange = function() {
        if (!this.currentiFrame) {
            return false;
        }
        this.currentiFrame.focus();
        if (this.currentEditor.getSelection) {
            var sel = this.currentEditor.getSelection();
            return sel && sel.getRangeAt && sel.rangeCount
                ? sel.getRangeAt(0)
                : false;
        }
        return false;
    };

    RVwys.runEvents_SourceView = function(oSourceEditor) {
        $.each(this.oEventsSourceView, function(k, v) {
            var func = v.func;
            $(oSourceEditor).bind(v.event, func);
        });
        var obj = this;

        $(oSourceEditor).keydown(function(e) {
            //return true;
            if (e.keyCode == '13') {
                var sel = obj.editorSource.getSelection();
                if (sel && sel.getRangeAt && sel.rangeCount) {
                    var range = sel.getRangeAt(0);
                    if (!range) {
                        return true;
                    }
                    var frag = range.cloneContents(),
                        node,
                        lastNode;
                    var oEle = document.createElement('div');
                    oEle.innerHTML = '<br class="srcEnter"/>';
                    while ((node = oEle.firstChild)) {
                        lastNode = frag.appendChild(node);
                    }
                    range.insertNode(frag);
                    if (lastNode) {
                        range = range.cloneRange();
                        range.setStartAfter(lastNode);
                        range.collapse(true);
                        sel.removeAllRanges();
                        sel.addRange(range);
                    }
                    return false;
                }
                return false;
            }
        });

        $(oSourceEditor).keyup(function(e) {
            //return true;
            if (obj.processUpdateDesign) {
                clearTimeout(obj.processUpdateDesign);
            }
            var oSrcEditor = $(oSourceEditor);
            obj.processUpdateDesign = setTimeout(function() {
                //alert(obj.processUpdateDesign)
                obj.updateDesign(obj.currentiFrame, oSrcEditor);
                //clearTimeout(this);
            }, 1000);
        });
        /*
        $(oSourceEditor).mouseover(function(e){
        	parent.pointerMode = 'source';
        	//alert(parent.scrollSourceModeInVal)

        });
        */
        $(oSourceEditor).mouseup(function(e) {
            //return true;
            var oSrcEditor = $(oSourceEditor);

            obj.processUpdateDesign = setTimeout(function() {
                var selSource = RVwys.editorFrameDoc.getSelection();
                if (selSource && selSource.getRangeAt && selSource.rangeCount) {
                    var range = selSource.getRangeAt(0);
                } else {
                    var range = false;
                }
                //if (range && (range.startOffset - range.endOffset != 0)) {
                obj.updateDesign(obj.currentiFrame, oSrcEditor);
                clearTimeout(this);
                //}
            }, 50);
        });

        $(oSourceEditor).mousedown(function(e) {
            //return true;
            var selDesign = RVwys.currentEditor.getSelection();
            var oFocusDesign = $(RVwys.currentiFrame).find('.pointer');
            var oFocusObjDesign = $(RVwys.currentiFrame).find('.focus');
            parent.pointerMode = 'source';

            //selDesign.removeAllRanges();

            //alert('oFocusDesign'+oFocusDesign.text())
            /*
        	if (oFocusDesign.get(0)) {
        		if (oFocusDesign.text() != '') {
        			oFocusDesign.replaceWith(oFocusDesign.text());
        		} else {
        			oFocusDesign.remove();
        		}
        	} 
        	if(oFocusObjDesign.get(0)) {
        		if (oFocusObjDesign.text() != '') {
        			oFocusObjDesign.replaceWith(oFocusObjDesign.html());
        		} else {
        			oFocusObjDesign.remove();
        		}
        	}
        	*/
            //alert(parent.scrollSourceModeInVal)
            var editorFrameSource = $(RVwys.editorFrameSource)
                .contents()
                .find('focus');
            //alert(editorFrameSource.text())
            /*
    		if(editorFrameSource.html() !='') {
    			//alert(editorFrameSource.text())
    			editorFrameSource.replaceWith(editorFrameSource.html());    			
    		}
    		*/
            return true;
        });

        return this;
    };

    RVwys.htmlSpecialChars = function(str, ignoreEscaped) {
        str = String(str);
        if (!ignoreEscaped) {
            str = str.replace(/&/gi, '&amp;');
        } else {
            str = str.replace(/&(?!([a-z0-9#]{2,10};))/gi, '&amp;');
        }
        return str
            .replace(/\xA0/gi, '&nbsp;')
            .replace(/</gi, '&lt;')
            .replace(/>/gi, '&gt;')
            .replace(/"/gi, '&quot;');
    };

    RVwys.syntaxHighlight = function(html) {
        html = RVwys.htmlSpecialChars(html);
        html = html
            .replace('|wproSelectionStart|', '<span id="selection">')
            .replace('|wproSelectionEnd|', '</span>');
        html = html.replace(
            /(&lt;(p|div)><span id=\"selection\"><\/span>)(&lt;\/(p|div)>)/gi,
            '$1&amp;nbsp;$3'
        );
        var htmlTag = /(&lt;([\s\S]*?)&gt;)/gi;
        var styleTag = /(&lt;(style|\/style)([\s\S]*?)&gt;)/gi;
        var tableTag = /(&lt;(table|tbody|th|tr|td|\/table|\/tbody|\/th|\/tr|\/td)([\s\S]*?)&gt;)/gi;
        var formTag = /(&lt;(form|input|textarea|button|select|option|\/form|\/input|\/textarea|\/button|\/select|\/option)([\s\S]*?)&gt;)/gi;
        var commentTag = /(&lt;!--([\s\S]*?)--&gt;)/gi;
        var imageTag = /(&lt;img([\s\S]*?)&gt;)/gi;
        var linkTag = /(&lt;(a|\/a)([\s\S]*?)&gt;)/gi;
        var scriptTag = /(&lt;(script|\?[^x]|%|\/script)([\s\S]*?)&gt;)/gi;
        var objectTag = /(&lt;(applet|object|\/applet|\/object)([\s\S]*?)&gt;)/gi;
        var attributeValue = /(=)(&quot;([\s\S]*?)&quot;)/gi;
        var specChar = /(&amp;[a-z0-9#]{2,10};)/gi;
        html = html
            .replace(htmlTag, '<span class="fSrc">$1</span>')
            .replace(styleTag, '<span class="styleTag">$1</span>')
            .replace(formTag, '<span class="formTag">$1</span>')
            .replace(tableTag, '<span class="tableTag">$1</span>')
            .replace(commentTag, '<span class="commentTag">$1</span>')
            .replace(imageTag, '<span class="imageTag">$1</span>')
            .replace(linkTag, '<span class="linkTag">$1</span>')
            .replace(scriptTag, '<span class="scriptTag">$1</span>')
            .replace(objectTag, '<span class="objectTag">$1</span>')
            .replace(attributeValue, '$1<span class="attributeValue">$2</span>')
            .replace(specChar, '<span class="character">$1</span>');
        html = html.replace(/\n/gi, '<br>');
        //html = this.triggerHTMLFilter('syntax', html);
        return html;
    };

    RVwys.updateSource = function() {
        var content = $(RVwys.currentiFrame).html();

        if (parent.$('#editorSource').is(':visible')) {
            var range = RVwys.getRange();
            if (range) {
                var html = '';
                RVwys.startOffset = range.startOffset;
                RVwys.endOffset = range.endOffset;
                var startContent = range.startContainer;
                var endContent = range.endContainer;
                var clonedSelection = range.cloneContents();
                /* event focus content
				var eR = range.cloneRange();
				var sR = range.cloneRange();
				var sN = RVwys.currentEditor.createElement('focus');
				var eN = RVwys.currentEditor.createElement('endfocus');
				
				eR.collapse(false);
				eR.insertNode(eN);
				sR.collapse(true);
				sR.insertNode(sN);
				var sel = RVwys.currentEditor.getSelection();
				sel.setBaseAndExtent(sN, 0, eN,1);
				*/
                //alert(html)
                var hol = $('<div>');
                hol.html($(RVwys.currentiFrame).html()).unplaceHolders();
                var event = jQuery.Event('editorSource');
                event.hol = hol;
                $(document).trigger(event);
                $(RVwys.currentiFrame)
                    .find('focus')
                    .remove();
                $(RVwys.currentiFrame)
                    .find('endfocus')
                    .remove();
                hol.find('.layoutResize').remove();
                hol.find('.wgetAll').remove();
                var html = event.hol.html();
                //set focus
                html = html.replace('<focus></focus>', '#focus#');
                html = html.replace('<endfocus></endfocus>', '#/focus#');

                var openTag = 0;
                var closeTag = 0;

                //alert(html)
                //&lt;!--?

                html = html
                    .replace(/\&lt;!--\?/gim, '#amplt;?')
                    .replace(/\?--\&gt;/gim, '?#ampgt;')
                    .replace(/\&/gim, '&amp;')
                    .replace(/\#amplt;/gim, '&lt;')
                    .replace(/\#ampgt;/gim, '&gt;')
                    .replace(/(<[^>]*?>)/gim, function(m, i) {
                        if (
                            i.match(
                                /(jotForm|onlineForm|onlineFlash|fbComment|fbpageplugin|fbLikebox|fbLikebutton)/gim
                            )
                        ) {
                            return i;
                        }
                        var str = '';
                        var tagAttribute = i;
                        var iTag = i
                            .replace(/</gi, '&lt;')
                            .replace(/>/gi, '&gt;');
                        if (i.match(/^<\//i)) {
                            closeTag--;
                            str =
                                '<span id="endtagObj' +
                                closeTag +
                                '" target="tagObj' +
                                closeTag +
                                '"class="fSrc">' +
                                iTag +
                                '</span>';
                        } else {
                            str =
                                '<span id="tagObj' +
                                openTag +
                                '"class="fSrc">' +
                                iTag +
                                '</span>';
                            openTag++;
                            closeTag = openTag;
                        }
                        return str;
                    });
                html = html.replace('#focus#', '<focus>');
                html = html.replace('#/focus#', '</focus>');
                //alert('updatesource set-->'+ html)
                //console.log('$(parent.RVwys.editorSource).get(0)-->'+$(parent.RVwys.editorSource).get(0));
                if (!$(parent.RVwys.editorSource).get(0)) {
                    parent.RVwys.editorSource = RVwys.reloadObjEditorSource();
                }
                parent.RVwys.displaySource(RVwys.currentiFrame);
                $(parent.RVwys.editorSource)
                    .contents()
                    .find('body')
                    .html(html)
                    .each(function() {
                        RVwys.scrollSourceMode();
                    });
            }
        }
    };

    RVwys.updateDesign = function(oEditor, oThis) {
        var editorSource = oThis.get(0);
        var oFocus = $(RVwys.editorSource).find('focus');
        var oFocusObj = $(RVwys.editorSource).find('focusobj');
        var oFocusArea = $(RVwys.editorSource).find('.focus');
        var inTagCase = false;
        var noneFocus = true;
        if (oFocus.text() != '') {
            oFocus.replaceWith(oFocus.html());
        }
        if (oFocusObj.text() != '') {
            oFocusObj.replaceWith(oFocusObj.html());
        }

        if (oFocusArea.html() != '') {
            oFocusArea.replaceWith(oFocusArea.html());
        }

        var sel = RVwys.editorFrameDoc.getSelection();
        var tagfocus = false;
        if (sel && sel.getRangeAt && sel.rangeCount) {
            var range = sel.getRangeAt(0);
            var startContent = range.startContainer;
            var endContent = range.endContainer;
            var clonedSelection = range.cloneContents();
            var eR = range.cloneRange();
            var sR = range.cloneRange();
            isStartTag = $(startContent).parent();
            if (isStartTag.attr('class') == 'fSrc') {
                var isTagHG, isEndTagHG;
                if (isStartTag.attr('target')) {
                    isTagHG = $(RVwys.editorSource).find(
                        '#' + isStartTag.attr('target')
                    );
                    isEndTagHG = $(RVwys.editorSource).find(
                        '#end' + isStartTag.attr('target')
                    );
                } else {
                    isTagHG = isStartTag;
                    isEndTagHG = $(RVwys.editorSource).find(
                        '#end' + isStartTag.attr('id')
                    );
                }
                var elementFocus = isTagHG.html();

                if (!elementFocus.match(/&lt;(?:img)/gi)) {
                    var elementFocusEnd = isTagHG.next().html();
                    isTagHG.prepend('<focusobj></focusobj>');
                    isEndTagHG.append('<endfocusobj></endfocusobj>');
                    var isTag = elementFocus.match(/&lt;(?:div|table|p)/gi);
                    var tagfocus = isTag ? 'div' : 'span';
                    inTagCase = true;
                } else {
                    noneFocus = false;
                }
            }
            noneFocus = false;
            if (noneFocus) {
                var sN = RVwys.editorSource.createElement('focus');
                var eN = RVwys.editorSource.createElement('endfocus');
                //alert(sel)
                eR.collapse(false);
                eR.insertNode(eN);
                sR.collapse(true);
                sR.insertNode(sN);
                sel.setBaseAndExtent(sN, 0, eN, 1);
            }
        }

        var event = jQuery.Event('editorDesign');
        event.hol = oThis.placeHolders();
        $(document).trigger(event);
        html = event.hol.html();
        if (inTagCase) {
            html = html.replace(/(&lt;(?!:&gt;).*?&gt;)/gim, function(m, str) {
                //alert(m)
                if (str) {
                    data = str.replace(/(<focus><\/focus>)/gim, '');
                    data = data.replace(/(<endfocus><\/endfocus>)/gim, '');
                    return data;
                }
                return m;
            });
        }

        html = html.replace(
            /<focus><\/focus>(.*?(<span[^>]*?>).*?)<endfocus><\/endfocus>/gim,
            function(m, isFocus, isSpan) {
                if (isFocus) {
                    isFocus = '<focus></focus>' + isFocus;
                    isFocus =
                        isFocus.replace(isSpan, '') + '<endfocus></endfocus>';
                    isFocus = isFocus.replace(
                        /(&lt;.*?)(<endfocus><\/endfocus>)/gim,
                        '$2$1'
                    );
                    //isFocus = isFocus.replace(isSpan,'<endfocus></endfocus>'+isSpan);
                    //alert(isFocus)
                    return isFocus;
                }
                return m;
            }
        );

        html = html.replace('<focus></focus>', '&lt;focus&gt;');
        html = html.replace('<endfocus></endfocus>', '&lt;/focus&gt;');

        if (tagfocus) {
            html = html.replace(
                '<focusobj></focusobj>',
                '&lt;' + tagfocus + ' class="focus" &gt;'
            );
            html = html.replace(
                '<endfocusobj></endfocusobj>',
                '&lt;/' + tagfocus + '&gt;'
            );
        }

        $(RVwys.editorSource)
            .find('focus')
            .each(function() {
                $(this).replaceWith($(this).html());
            });
        $(RVwys.editorSource)
            .find('endfocus')
            .each(function() {
                $(this).replaceWith($(this).html());
            });
        $(RVwys.editorSource)
            .find('focusobj')
            .each(function() {
                $(this).replaceWith($(this).html());
            });
        $(RVwys.editorSource)
            .find('endfocusobj')
            .each(function() {
                $(this).replaceWith($(this).html());
            });
        $(RVwys.editorSource)
            .find('focus')
            .remove();
        $(RVwys.editorSource)
            .find('endfocus')
            .remove();
        $(RVwys.editorSource)
            .find('focusobj')
            .remove();
        $(RVwys.editorSource)
            .find('endfocusobj')
            .remove();
        //alert(holdHTML)
        var holdHTML = $('<div/>');
        holdHTML.addClass('holdhtml');
        holdHTML.html(html);
        var html = holdHTML.text();
        html = html.replace(/<\?/gim, '<!--?').replace(/\?>/gim, '?-->');
        holdHTML.html(html);
        html = holdHTML.placeHoldersRaw().html();
        holdHTML.remove();
        $(oEditor)
            .html(html)
            .each(function() {
                RVwys.scrollDesignMode();
            });
        //alert($(oEditor).html())
        return;
        /*
			/<(?!br|\/br|input|\/input|area|\/area|base|\/base|col|\/col|frame|\/frame|hr|\/hr|img|\/img|isindex|\/isindex|link|\/link|meta|\/meta|param|\/param).*?>/img
		 */
        $(oEditor).html(textDatas);
        $(oEditor)
            .find('.srcEnter')
            .remove();
    };

    RVwys.scrollSourceMode = function() {
        try {
            var currentEdit = $(parent.RVwys.editorFrameSource)
                .contents()
                .find('focus');
            //alert(currentEdit.get(0))
            var userSelection = parent.RVwys.editorSource.getSelection();
            if (currentEdit.get(0)) {
                if (userSelection) {
                    userSelection.setBaseAndExtent(
                        currentEdit.get(0),
                        0,
                        currentEdit.get(0),
                        2
                    );
                    if (parent.pointerMode == 'design') {
                        if (currentEdit.get(0)) {
                            $(parent.RVwys.editorSource).scrollTop(
                                currentEdit.offset().top
                            );
                        }
                    }
                }
            }
        } catch (e) {}
    };

    RVwys.scrollDesignMode = function() {
        return false;
        var isFocus = $(RVwys.currentiFrame).find('focus');
        //alert(isFocus.get(0))
        currentEdit = isFocus;
        currentEdit.addClass('pointer');
        pointerFocus = currentEdit;
        if (currentEdit.get(0)) {
            //alert(currentEdit.get(0))
            userSelection = this.currentEditor.getSelection();
            if (userSelection) {
                userSelection.setBaseAndExtent(
                    currentEdit.get(0),
                    0,
                    currentEdit.get(0),
                    1
                );
            }
        } else {
            pointerFocus = $(RVwys.currentiFrame).find('.focus');
        }
        //alert(RVwys.pointerMode)
        if (parent.pointerMode == 'source') {
            if (pointerFocus.get(0)) {
                pp =
                    pointerFocus.offset().top -
                    $(RVwys.currentiFrame).offset().top;
                $(RVwys.currentEditor).scrollTop(pp + 200);
            }
        }
    };

    RVwys.selectElement = function(element) {
        if (window.getSelection) {
            var sel = window.getSelection();
            sel.removeAllRanges();
            var range = document.createRange();
            range.selectNodeContents(element);
            sel.addRange(range);
        }
    };

    $(window).resize(function() {
        RVwys.setPositionTheme();
    });
})(jQuery);
